<!-- 生产数量 -->
<template>
    <span>
        <template v-if="+customPcbBan === 1">
            <span class="number-tips-span" v-if="units === 3">
                请注意SMT套数，不可超过PCB未拼板前数量
            </span>
            <template v-else>
                <span class="number_tips" v-if="pcbNumber > 0 && pcbNumber < number">请输入1~{{ pcbNumber }}的数量</span>
            </template>
        </template>
        <template v-else-if="+customPcbBan === 2">
            <template v-if="pcbNumber > 0">
                <span class="number_tips" v-if="pcbNumber < number">请输入1~{{ pcbNumber }}的数量</span>
            </template>
            <span class="number-tips-span" v-else>
                建议SMT的生产数量不能大于PCB的片数（Pcs）
            </span>
        </template>
        <span class="number-tips-span" v-else>
            建议SMT的生产数量不能大于PCB的片数（Pcs）
        </span>
    </span>
</template>

<script>

export default {
    props: {
        // 生产数量
        number: {
            type: [Number, String],
            default: 1
        },
        // 生产数量类型: 1-PCB数量全贴 0-其他数量
        number_type: {
            type: Number,
            default: 1
        },
        // PCB数量
        pcbNumber: {
            type: Number,
            default: 0
        },
        units: {
            type: [Number, String],
            default: ''
        },
        customPcbBan: {
            type: [Number, String],
            default: ''
        },
    },
    data() {
        return {
           
        }
    },
}
</script>

<style lang="scss" scoped>
.number-tips-span {
    font-size: 12px;
    color: #E6A23C;
}

.number_tips {
    color: #FF4D4F;
}
</style>